<div class="promotion-code-child-component">
  <h5>{{ isFreeSpin ? 'Eligible Type Setting' : 'Member Setting' }}</h5>
  <div class="promotion-code-child-component-content">
    <form [formGroup]="form">

      <div *ngIf="feedbackMsg" class="alert alert-info alert-dismissible py-2 px-3 mb-3 d-flex justify-content-between align-items-center" style="font-size:13px;">
        <span>{{ feedbackMsg }}</span>
        <button type="button" class="close" aria-label="Close" (click)="feedbackMsg=''" style="position:static; padding:0; line-height:1;"><span aria-hidden="true">&times;</span></button>
      </div>

      <!-- PP / non-Free-Spin: plain member group (unchanged) -->
      <div class="row" *ngIf="!isFreeSpin">
        <div class="col-12 mb-4">
          <span class="kt-font-bold">Member Group</span>
          <kt-dropdown-wo-lazyload [form]='form' [dropdownList]='groupDropdownList' [dropdownSettings]='groupDropdownSettings' [formName]="'member_group_ids'" [selectionAttributes]="'id'" [selectedItems]='groupSelectedItems' [dataLoading]='memberGroupLoading'></kt-dropdown-wo-lazyload>
        </div>
      </div>

      <!-- Free Spin: full Eligible Type Setting (AIO-71840) -->
      <ng-container *ngIf="isFreeSpin">
        <div class="mb-2"><span class="kt-font-bold">Eligible Type <span class="text-danger">*</span></span></div>
        <div class="row">
          <div class="col-3 mb-4" *ngFor="let t of eligibleTypes">
            <div class="eligible-type-card" (click)="selectEligibleType(t.id)"
                 [ngStyle]="{'border': (+form.value.eligible_types === t.id) ? '1px solid #3699FF' : '1px solid #E4E6EF', 'border-radius': '8px', 'padding': '16px', 'cursor': 'pointer', 'display': 'flex', 'justify-content': 'space-between', 'align-items': 'center', 'height': '100%'}">
              <span class="kt-font-bold">{{ t.name }}</span>
              <input type="radio" formControlName="eligible_types" [value]="t.id" (change)="onEligibleTypeChange()" (click)="$event.stopPropagation()">
            </div>
          </div>
        </div>

        <!-- Member (1) -->
        <ng-container *ngIf="+form.value.eligible_types === 1">
          <div class="row">
            <div class="col-12 mb-4">
              <span class="kt-font-bold">Member Group</span>
              <kt-dropdown-wo-lazyload [form]='form' [dropdownList]='groupDropdownList' [dropdownSettings]='groupDropdownSettings' [formName]="'member_group_ids'" [selectionAttributes]="'id'" [selectedItems]='groupSelectedItems' [dataLoading]='memberGroupLoading'></kt-dropdown-wo-lazyload>
            </div>
            <div class="col-4 mb-4">
              <span class="kt-font-bold">Visible by Affiliate</span>
              <div class="toggle-button">
                <p>Selected affiliates can create and view campaigns.</p>
                <div class="switch">
                  <input type="checkbox" formControlName="visible_by_affiliate" [checked]="form.value.visible_by_affiliate == 1" (change)="onChangeToggle($event, 'visible_by_affiliate')">
                  <div class="slider round"><span class="on">ON</span><span class="off">OFF</span></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Affiliate List (shown when Visible by Affiliate is ON) -->
          <div class="row" *ngIf="form.value.visible_by_affiliate == 1">
            <div class="col-12 mb-4">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <span class="kt-font-bold">Affiliate List</span>
                <button type="button" class="btn btn-primary btn-sm" (click)="addAffRow()"><i class="fa fa-plus"></i> ADD</button>
              </div>
              <table class="table table-bordered" formArrayName="promotion_affiliate_group">
                <thead>
                  <tr>
                    <th style="width:30%">Affiliate Group</th>
                    <th style="width:20%">Visibility</th>
                    <th>Affiliates</th>
                    <th style="width:10%" class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let row of promoAffGroups.controls; let i = index">
                  <tr *ngIf="i >= (affPage - 1) * affPageSize && i < affPage * affPageSize" [formGroupName]="i">
                    <td>
                      <select class="form-control" formControlName="affiliate_group_id" [attr.disabled]="affiliateGroupLoading ? true : null">
                        <option [ngValue]="null" disabled>Please Select</option>
                        <option *ngFor="let ag of affiliateGroupDropdownList" [ngValue]="ag.id">{{ ag.name }}</option>
                      </select>
                    </td>
                    <td>
                      <select class="form-control" formControlName="visibility" (change)="onRowVisibilityChange(i)">
                        <option [ngValue]="1">All</option>
                        <option [ngValue]="2">Include Selected</option>
                        <option [ngValue]="3">Exclude Selected</option>
                      </select>
                    </td>
                    <td>
                      <kt-dropdown-wo-lazyload *ngIf="+row.value.visibility > 1"
                        [form]='row'
                        [dropdownList]='affiliateListDropdownList'
                        [dropdownSettings]='affiliateDropdownListSettings'
                        [formName]="'affiliate_id'"
                        [selectionAttributes]="'id'"
                        [selectedItems]='affiliateListSelectedItems[i]'
                        [dataLoading]='affiliateLoading'>
                      </kt-dropdown-wo-lazyload>
                    </td>
                    <td class="text-center">
                      <button type="button" class="btn btn-icon btn-sm btn-outline-hover-danger" (click)="removeAffRow(i)"><i class="fas fa-trash-alt"></i></button>
                    </td>
                  </tr>
                  </ng-container>
                  <tr *ngIf="promoAffGroups.controls.length === 0">
                    <td colspan="4" class="text-center text-muted">No affiliate groups added.</td>
                  </tr>
                </tbody>
              </table>
              <!-- Same ngb-pagination + toolbar as the listing pages (3.2.1), just driven by local page state -->
              <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="promoAffGroups.controls.length > 0">
                <ngb-pagination
                  [pageSize]="affPageSize"
                  [(page)]="affPage"
                  [maxSize]="5"
                  [directionLinks]="true"
                  [boundaryLinks]="true"
                  [rotate]="true"
                  [collectionSize]="promoAffGroups.controls.length">
                </ngb-pagination>
                <div class="kt-pagination__toolbar">
                  <select class="form-control kt-font-brand page-size" [value]="affPageSize" (change)="affOnPageSize($event.target.value)">
                    <option [value]="10">10</option>
                    <option [value]="30">30</option>
                    <option [value]="50">50</option>
                  </select>
                  <span class="pagination__desc">
                    Showing {{ affShowingFrom() }} to {{ affShowingTo() }} of {{ promoAffGroups.controls.length }} records
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Members under Affiliate (2) -->
        <div class="row" *ngIf="+form.value.eligible_types === 2">
          <div class="col-12 mb-4">
            <span class="kt-font-bold">Affiliate Group</span>
            <kt-dropdown-wo-lazyload [form]='form' [dropdownList]='affiliateGroupDropdownList' [dropdownSettings]='affiliateGroupDropdownSettings' [formName]="'affiliate_group_ids'" [selectionAttributes]="'id'" [selectedItems]='affiliateGroupSelectedItems' [dataLoading]='affiliateGroupLoading'></kt-dropdown-wo-lazyload>
          </div>
          <div class="col-12 mb-4">
            <span class="kt-font-bold">Affiliate List</span>
            <table class="table table-bordered mt-2">
              <thead>
                <tr>
                  <th>Username</th>
                  <th>Affiliate Group</th>
                  <th class="text-center" style="width:15%">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colspan="2">
                    <kt-dropdown-wo-lazyload
                      [form]='affiliateAddForm'
                      [dropdownList]='availableAffiliateList'
                      [dropdownSettings]='affiliateAddDropdownSettings'
                      [formName]="'affiliate_to_add'"
                      [selectionAttributes]="'id'"
                      [selectedItems]='affiliateToAddSelectedItems'
                      [dataLoading]='affiliateLoading'>
                    </kt-dropdown-wo-lazyload>
                  </td>
                  <td class="text-center">
                    <button type="button" class="btn btn-primary btn-sm" (click)="addAffiliateId()"><i class="fa fa-plus"></i> ADD</button>
                  </td>
                </tr>
                <ng-container *ngFor="let a of selectedAffiliates(); let i = index">
                  <tr *ngIf="i >= (affListPage - 1) * affListPageSize && i < affListPage * affListPageSize">
                    <td>{{ a.username }}</td>
                    <td>{{ a.affiliate_group_name || a.group_name || a.affiliate_group || '-' }}</td>
                    <td class="text-center">
                      <button type="button" class="btn btn-icon btn-sm btn-outline-hover-danger" (click)="removeAffiliateId(a.id)"><i class="fas fa-times"></i></button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
            <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="selectedAffiliates().length > 0">
              <ngb-pagination
                [pageSize]="affListPageSize"
                [(page)]="affListPage"
                [maxSize]="5"
                [directionLinks]="true"
                [boundaryLinks]="true"
                [rotate]="true"
                [collectionSize]="selectedAffiliates().length">
              </ngb-pagination>
              <div class="kt-pagination__toolbar">
                <select class="form-control kt-font-brand page-size" [value]="affListPageSize" (change)="affListOnPageSize($event.target.value)">
                  <option [value]="10">10</option>
                  <option [value]="30">30</option>
                  <option [value]="50">50</option>
                </select>
                <span class="pagination__desc">
                  Showing {{ affListShowingFrom() }} to {{ affListShowingTo() }} of {{ selectedAffiliates().length }} records
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Referral (3) -->
        <div class="row" *ngIf="+form.value.eligible_types === 3">
          <div class="col-12 mb-4">
            <span class="kt-font-bold">Member Group</span>
            <kt-dropdown-wo-lazyload [form]='form' [dropdownList]='groupDropdownList' [dropdownSettings]='groupDropdownSettings' [formName]="'member_group_ids'" [selectionAttributes]="'id'" [selectedItems]='groupSelectedItems' [dataLoading]='memberGroupLoading'></kt-dropdown-wo-lazyload>
          </div>
        </div>

        <!-- Telemarketer / Account Manager (4) -->
        <div class="row" *ngIf="+form.value.eligible_types === 4">
          <div class="col-4 mb-4">
            <span class="kt-font-bold">Telemarketer</span>
            <kt-dropdown-wo-lazyload [form]='form' [dropdownList]='telemarketerDropdownList' [dropdownSettings]='boUserDropdownSettings' [formName]="'telemarketer_ids'" [selectionAttributes]="'id'" [selectedItems]='telemarketerSelectedItems' [dataLoading]='boUserLoading'></kt-dropdown-wo-lazyload>
          </div>
          <div class="col-4 mb-4">
            <span class="kt-font-bold">Account Managers</span>
            <kt-dropdown-wo-lazyload [form]='form' [dropdownList]='normalAccountManagerDropdownList' [dropdownSettings]='boUserDropdownSettings' [formName]="'normal_account_manager_ids'" [selectionAttributes]="'id'" [selectedItems]='normalAccountManagerSelectedItems' [dataLoading]='boUserLoading'></kt-dropdown-wo-lazyload>
          </div>
          <div class="col-4 mb-4">
            <span class="kt-font-bold">Vip Account Managers</span>
            <kt-dropdown-wo-lazyload [form]='form' [dropdownList]='vipAccountManagerDropdownList' [dropdownSettings]='boUserDropdownSettings' [formName]="'vip_account_manager_ids'" [selectionAttributes]="'id'" [selectedItems]='vipAccountManagerSelectedItems' [dataLoading]='boUserLoading'></kt-dropdown-wo-lazyload>
          </div>
        </div>
      </ng-container>

    </form>
  </div>
</div>
